import styled from 'styled-components';

export const LoadingContainer = styled.div`
  align-self: center;
  margin: auto;
  font-size: 32px;
`;
